import { FormLabel } from '@chakra-ui/react'
import * as React from 'react'

import { Text } from '~ui/components/typography/Text/Text'

import { FORM_LABEL_SPACE_LEFT } from './formAccessories.config'
import { RequiredIndicator } from './RequiredIndicator'

type TProps = RequiredChildren & Omit<PropsOf<typeof Text>, 'as' | 'display'>

/**
 * text label of the form input
 * use inside the `InputControl` component:
 *  - to connect it with near inputs
 *  - to show the `requiredIndicator` if the input is required
 * https://chakra-ui.com/docs/components/form/form-control#making-a-field-required
 */
export const InputLabel: React.FC<TProps> = ({
  children,
  contrast = `low`,
  padding = { left: FORM_LABEL_SPACE_LEFT, bottom: `small`, right: `none`, top: `none` },
  ...textProps
}) => {
  return (
    <FormLabel cursor={`unset`} requiredIndicator={<RequiredIndicator {...textProps} />}>
      <Text
        {...textProps}
        as={`span`}
        padding={padding}
        contrast={contrast}
        display={`inline-block`}
      >
        {children}
      </Text>
    </FormLabel>
  )
}
